import script from "./FieldPropertyBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./FieldPropertyBlock.vue?vue&type=script&setup=true&lang=js"

import "./FieldPropertyBlock.vue?vue&type=style&index=0&id=4e0fd33a&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e0fd33a"]])

export default __exports__